import request from '@/utils/request'
export function getMyEmployer() {
  return request({
    url: '/seting/getMyEmployer' ,
    method: 'get'
  })
}
export function updateEmployer(id, data) {
  return request({
    url: '/seting/update/' + id,
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/seting.js